export default {
  tableRules: {
    lengthMenu: [10, 20, 50, 100],
    allowPaging: true,
    showFormSearch: true,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "-changed_at",
    data: [],
    activeFilters: {},
    dataSearch: {
      value: {
        condition:             "",
        company_id:            "",
        change_source:         "",
        changed_at_from:       "",
        changed_at_to:         "",
        target_work_date_from: "",
        target_work_date_to:   "",
      },
    },
  },
};
